import { ref, onMounted } from 'vue'
import axios from 'axios'

export default function (props) {
  const contact = ref({
    name: '',
    contact: '',
    message: ''
  })

  const errors = ref({})
  const step = ref('form')

  const sendForm = async () => {
    try {
      // Очищаем ошибки перед отправкой
      errors.value = {}

      const response = await axios.post(props.apiUrl, contact.value)
      step.value = 'complete'

      // Яндекс Метрика (если есть)
      if (props.metrikaJsId && typeof ym === 'function') {
        try {
          ym(Number(document.querySelector('script[src*="metrika"]')?.src?.match(/\d+/)?.[0] || 0), 'reachGoal', props.metrikaJsId)
        } catch (e) {
          console.warn('YM not available')
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        // Ошибки валидации DRF приходят в data
        errors.value = error.response.data
      } else {
        errors.value = { detail: 'Произошла ошибка при отправке. Попробуйте позже.' }
      }
    }
  }

  const resetForm = () => {
    contact.value = { name: '', contact: '', message: '' }
    errors.value = {}
    step.value = 'form'
  }

  return {
    contact,
    errors,
    step,
    sendForm,
    resetForm
  }
}
